import { useEffect, useRef, useState, type RefObject } from "react"

export const useLazyLoad = (
  rootMargin = "240px 0px",
): { ref: RefObject<HTMLDivElement | null>; shouldLoad: boolean } => {
  const ref = useRef<HTMLDivElement>(null)
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    const target = ref.current
    if (!target || shouldLoad) return

    if (!window.IntersectionObserver) {
      setShouldLoad(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return
        setShouldLoad(true)
        observer.disconnect()
      },
      { rootMargin },
    )
    observer.observe(target)

    return () => observer.disconnect()
  }, [rootMargin, shouldLoad])

  return { ref, shouldLoad }
}
